import { PhysicalProductTabEnum } from 'modules/stores/store/content/product/physical-product/enum/physical-product-tab-enum'

export const getNextTab = (tab: PhysicalProductTabEnum) => {
  const tabs = [
    PhysicalProductTabEnum.thumbnail,
    PhysicalProductTabEnum.physical_product,
    PhysicalProductTabEnum.checkout,
    PhysicalProductTabEnum.thank_you,
  ]

  const currentTabIndex = tabs.indexOf(tab)

  return tabs[currentTabIndex + 1]
}
